import { render, staticRenderFns } from "./System.vue?vue&type=template&id=31e69779&scoped=true&"
import script from "./System.vue?vue&type=script&lang=ts&"
export * from "./System.vue?vue&type=script&lang=ts&"
import style0 from "./System.vue?vue&type=style&index=0&id=31e69779&lang=less&scoped=true&"
import style1 from "./System.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e69779",
  null
  
)

export default component.exports